import { calculateSize } from './';

// Old function in place until new function is finished

function getCalculatedText(caption, options = {}) {
  if (!caption) return caption;

  const {
    numberOfLines = 3,
    width = 403,
    addToStart = '',
    textStyle = {},
    wrapperStyle = {}
  } = options;

  // Generate the style sheets for the components to be created
  const opt = {
    wrapperStyle: {
      width: `${width}px`,
      'word-break': 'break-word',
      lineHeight: '18px',
      ...wrapperStyle
    },
    textStyle: {
      textAlign: 'left',
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'CeraPro',
      'word-break': 'break-word',
      ...textStyle
    },
    addToStart,
    numberOfLines
  };

  const dimensions = calculateSize(caption, opt);

  return dimensions.calculatedText;
}

export default getCalculatedText;
